enum EApiShipment {
  shipment = '/externals/shipments',
  shipmentDetail = '/externals/shipments/:id',
  shipmentUpdateLog = '/externals/shipments/:id/update-logs',
}

export default EApiShipment;
